import { render, staticRenderFns } from "./BasicDialog.vue?vue&type=template&id=d323a83a&scoped=true"
import script from "./BasicDialog.vue?vue&type=script&lang=js"
export * from "./BasicDialog.vue?vue&type=script&lang=js"
import style0 from "./BasicDialog.vue?vue&type=style&index=0&id=d323a83a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d323a83a",
  null
  
)

export default component.exports